import React from "react";
import { Container, Typography, Paper, List, ListItem, ListItemText } from "@mui/material";



// refundReturnData.js
const refundReturnData = {
  title: "Refund & Return Policy – Yubai",
  description:
    "Thank you for shopping with Yubai. We are committed to ensuring your satisfaction and providing the best customer experience. Please read our policy carefully before initiating a return or refund request.",
  sections: [
    {
      heading: "1. Returns",
      points: [
        "Eligibility: Returns are accepted only in cases where incorrect items have been delivered.",
        "Conditions: Products must be returned unused, in their original packaging, and accompanied by the order number and receipt.",
        "Notification Period: You must notify us within 2 days of delivery to be eligible for a return.",
      ],
    },
    {
      heading: "2. Refunds",
      points: [
        "Eligibility: Refunds are offered only if an item arrives damaged due to Yubai’s handling or logistics.",
        "Review Process: Once we receive your request and supporting evidence (e.g. photos), our team will assess and confirm eligibility.",
        "Refund Method: Refunds will be processed through the original payment method or provided as store credit, depending on your preference.",
        "Shipping Costs: In cases of wrong or damaged items, Yubai covers the return shipping costs.",
      ],
    },
    {
      heading: "3. Exchanges",
      points: ["Please Note: Yubai does not offer product exchanges at this time."],
    },
    {
      heading: "4. Damaged or Incorrect Items",
      points: [
        "If you receive a damaged or wrong item, please contact us within 2 days of delivery. You will be asked to provide your order number and photographic evidence of the issue.",
      ],
    },
    {
      heading: "5. How to Request a Return or Refund",
      points: [
        "To initiate a return or refund:",
        "Contact our Customer Support via WhatsApp at [00961 78 777 190]",
        "Be ready to share your order number, photos, and a brief description of the issue.",
      ],
    },
  ],
};




function RefundReturn() {
  return (
    <Container maxWidth="md" >
      <Paper
        elevation={0}
        sx={{ padding: "10px", marginTop: "20px", marginBottom: "20px" }}
      >
        {/* Title */}
        <Typography
          variant="h2"
          gutterBottom
          sx={{
            fontSize: { xs: "23px", sm: "23px", md: "24px" },
            fontFamily: "Poppins_600SemiBold",
            mb: 2,
            textAlign: "left",
            color: "text.primary",
          }}
        >
          {refundReturnData.title}
        </Typography>

   
        <Typography
          variant="body1"
          paragraph
          sx={{
            fontSize: { xs: "14px", sm: "14px", md: "18px" },
            lineHeight: 1.6,
            color: "#808080",
            mb: 2,
            fontFamily: "poppins",
            textAlign: "left",
          }}
        >
          {refundReturnData.description}
        </Typography>

        {/* Sections */}
        {refundReturnData.sections.map((section, index) => (
          <div key={index} >
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: "23px", sm: "23px", md: "24px" },
                // fontWeight: 700,
                // mb: 1,
                color: "text.primary",
                textAlign: "left",
                fontFamily: "Poppins_600SemiBold",
              }}
            >
              {section.heading}
            </Typography>

            <List >
              {section.points.map((point, i) => (
                <ListItem key={i} sx={{ display: "list-item", pl: 0,   py: 0.3, }}>
                  <ListItemText
                    primary={point}
                    primaryTypographyProps={{
                      sx: {
                        fontSize: { xs: "14px", sm: "14px" },
                        lineHeight: 1.5,
                        color: "#808080",
                     
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </div>
        ))}
      </Paper>
    </Container>
  );
}

export default RefundReturn;
